import { cva, type VariantProps } from 'class-variance-authority'
import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

export const badgeVariants = cva(
  'inline-flex max-w-full items-center gap-1 truncate border px-2 py-0.5 text-xs font-medium leading-4',
  {
    variants: {
      tone: {
        neutral: 'border-slate-200 bg-slate-100 text-slate-700',
        success: 'border-emerald-200 bg-emerald-50 text-emerald-700',
        danger: 'border-red-200 bg-red-50 text-red-700',
        warning: 'border-amber-200 bg-amber-50 text-amber-800',
        info: 'border-sky-200 bg-sky-50 text-sky-700',
        brand: 'border-brand-200 bg-brand-50 text-brand-700',
        teal: 'border-teal-100 bg-teal-50 text-teal-700',
      },
      shape: { pill: 'rounded-full', chip: 'rounded-md' },
    },
    defaultVariants: { tone: 'neutral', shape: 'pill' },
  },
)

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, shape, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone, shape }), className)} {...props} />
}
